import apiRequest from '../index'

export default {
  path: '/v1/pitlock/shopMenuListCalling',
  async get (pitlockStoreId) {
    await window.callNativeHTTPX()
    return apiRequest.get(`${this.path}?store_id=${pitlockStoreId}`, {
      headers: {
        'HTTP-X-DAPP-REQUESTTIME': window.DAPP_REQUESTTIME,
        'HTTP-X-DAPP-USERID': window.DAPP_USERID,
        'HTTP-X-DAPP-AUTHCD': window.DAPP_AUTHCD
      }
    })
  }
}
